<div
  class="reveal-overlay"
  *ngIf="isVisible"
  (click)="closeOnBgClick($event)"
  (keyup.escape)="modal.close.next({ modalId: modalId, canceled: true })"
>
  <div class="reveal" [ngClass]="revealSize" [class.transparent]="isTransparent" cdkTrapFocus cdkTrapFocusAutoCapture>
    <h3 *ngIf="modalTitle" class="word-break margin-right-2">{{ modalTitle | titlecase }}</h3>
    <ng-content></ng-content>

    <button
      class="close-button"
      type="button"
      (click)="modal.close.next({ modalId: modalId, canceled: true })"
      data-cy="close-modal-button"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
